export const getMaxNumberFromStringList = (list: string[]): number | null => {
  const numbers = list
    .map((item) => {
      const match = item.match(/\d+$/);
      return match ? parseInt(match[0], 10) : null;
    })
    .filter((n): n is number => n !== null);

  if (numbers.length === 0) {
    return null;
  }

  return Math.max(...numbers);
};
